<script>
  import Box from "./Box.svelte";

  let viewState = "home";
  let number = 1;
  let letter = "A";
  let letterOptions = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z"
  ];

  let letterCase = "upper";

  function startNumbersLesson() {
    viewState = "numbers";
    number = 1;
  }

  function startLettersLesson() {
    viewState = "letters";
    letter = "A";
    number = 0;
  }

  function startColorsLesson() {
    viewState = "colors";
  }

  function resetLessons() {
    viewState = "home";
  }

  function subtractNumber() {
    if (number === 0) {
      return;
    }
    number--;
  }

  function addNumber() {
    number++;
  }

  function subtractLetter() {
    if (number === 0) {
      letter = getLetter();
      return;
    }
    number--;

    letter = getLetter();
  }

  function addLetter() {
    if (number === 25) {
      letter = getLetter();
      return;
    }
    number++;

    letter = getLetter();
  }

  function getLetter() {
    if (letterCase === "upper") {
      return letterOptions[number].toUpperCase();
    }

    return letterOptions[number].toLowerCase();
  }

  function toggleletterCasing() {
    if (letterCase === "upper") {
      letterCase = "lower";
    } else {
      letterCase = "upper";
    }

    letter = getLetter();
  }
</script>

<style type="text/scss">
  main {
    text-align: center;
    margin: 0;
    display: flex;
    flex-direction: column;
    flex: 100%;
    height: 100%;

    div {
      width: 100%;
    }

    .option-wrapper {
      display: flex;
      flex-direction: column;
      flex: 100%;
      align-items: center;
    }

    .lessons {
      margin-top: 25px;
      display: flex;
      flex-direction: column;
      flex: 100%;
      align-items: center;

      button {
        border: 1px solid #5899e2;
        background-color: #65afff;
        color: white;
        width: 100%;
      }
    }

    .lesson-container-temp {
      font-size: 3rem;
      display: flex;
      flex-direction: column;
      flex: 100%;
      align-items: center;
      justify-content: center;
      position: relative;

      .result {
        display: flex;
        flex: 100%;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
    }

    .lesson-container {
      font-size: 20rem;
      display: flex;
      flex-direction: column;
      flex: 100%;
      align-items: center;
      justify-content: center;
      position: relative;

      .add {
        position: absolute;
        height: 100%;
        width: 50%;
        top: 0px;
        right: 0px;
      }

      .subtract {
        position: absolute;
        height: 100%;
        width: 50%;
        top: 0px;
        left: 0px;
      }

      .result {
        display: flex;
        flex: 100%;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }

      .toggle-case {
        width: 50px;
        height: 50px;
        position: absolute;
        bottom: 25px;
        right: 25px;
        z-index: 99999;
        border: 1px solid #5899e2;
        background-color: #65afff;
        color: white;
        font-size: 2rem;
        border-radius: 50%;
      }
    }

    .lesson-reset {
      display: flex;
      flex: 0 1 60px;
      align-items: center;
      justify-content: center;
      background-color: #274060;
      padding: 0 15px;

      button {
        border: 1px solid #5899e2;
        background-color: #65afff;
        color: white;
        width: 100%;
      }
    }
  }

  h1 {
    color: #ffffff;
    background-color: #274060;
    text-transform: uppercase;
    font-size: 2em;
    font-weight: 100;
    margin: 0;
  }

  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }
</style>

<main>
  <h1>learning with larson</h1>

  <div class="option-wrapper">

    {#if viewState === 'home'}
      <div class="lessons">
        <Box>
          <h2>Numbers</h2>
          <p>Lets learn our numbers...1 2 3</p>
          <button type="button" on:click={startNumbersLesson}>Begin</button>
        </Box>

        <Box>
          <h2>Letters</h2>
          <p>Lets learn our letters...A B C</p>
          <button type="button" on:click={startLettersLesson}>Begin</button>
        </Box>

        <Box>
          <h2>Colors</h2>
          <p>Lets learn our colors</p>
          <button type="button" on:click={startColorsLesson}>Begin</button>
        </Box>
      </div>
    {/if}

    {#if viewState === 'numbers'}
      <div class="lesson-container">
        <div class="subtract" on:click={subtractNumber} />
        <div class="add" on:click={addNumber} />
        <div class="result">{number}</div>
      </div>
    {/if}

    {#if viewState === 'letters'}
      <div class="lesson-container">
        <div class="toggle-case" on:click={toggleletterCasing}>Aa</div>
        <div class="subtract" on:click={subtractLetter} />
        <div class="add" on:click={addLetter} />
        <div class="result">{letter}</div>
      </div>
    {/if}

    {#if viewState === 'colors'}
      <div class="lesson-container-temp">Coming Soon...</div>
    {/if}

    {#if viewState !== 'home'}
      <div class="lesson-reset">
        <button type="button" on:click={resetLessons}>Start Over</button>
      </div>
    {/if}

  </div>

</main>
